import { Button } from '@/components/Button';

type Props = {
  onClickModal: () => void;
};

export default function LinkedAccountsNoData({ onClickModal }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-9">
      <p className="text-center text-base font-bold">
        ATSと連携して
        <br />
        複数求人を取り込めます。
      </p>
      <img src="/agent/linked_accounts/data.svg" alt="" width={100} height={100} />
      <Button type="button" className="h-[52px] w-[208px]" onClick={onClickModal}>
        さっそく取り込みを開始
      </Button>
    </div>
  );
}
